/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

import RenderObject from "App/geometry/objects/object";
import Binary from "App/geometry/objects_geometry/binary";
import Factory from "App/geometry/objects_geometry/factory";
import AbstractGeometry from "App/geometry/objects_geometry/abstract_geometry";
import {mat4} from "gl-matrix";

export default
class IndexedFacetSet extends Binary {

    public static TypeName: string = "indexedFaceSet";

    constructor(aObject: RenderObject) {
        super(aObject);
    }

    public static create(aObject: RenderObject) {
        return new IndexedFacetSet(aObject);
    }

    /***
     * Load data from object properties and fill attribute descriptors
     *
     * @param aBuffer Buffer is empty in this case as all the data is stored inside the object properties
     */
    public loadData(aBuffer: Uint8Array) {
        let data: any = {
            positions: null,
            normals: null,
            texCoords: null,
            indices: null
        };

        data.positions = new Float32Array(this.properties.positions);

        let repetitionTrafo = this.object.getElement().getRepetitionTransformation();
        if (repetitionTrafo) {
            data.positions = AbstractGeometry.transformArray(
                data.positions,
                this.properties.vertexCount,
                new Float32Array(repetitionTrafo)
            );
        }

        if (this.properties.normals !== undefined) {
            data.normals = new Float32Array(this.properties.normals);
        } else {
            data.normals = new Float32Array(this.properties.normalsCount * 3);
        }

        if (repetitionTrafo) {
            let rotationMat = mat4.clone(new Float32Array(repetitionTrafo));
            rotationMat[3] = 0.0;
            rotationMat[7] = 0.0;
            rotationMat[11] = 0.0;
            rotationMat[12] = 0.0;
            rotationMat[13] = 0.0;
            rotationMat[14] = 0.0;
            rotationMat[15] = 1.0;
            data.normals = AbstractGeometry.transformArray(
                data.normals,
                this.properties.normalCount,
                rotationMat
            );
        }

        if (this.properties.texCoords !== undefined) {
            data.texCoords = new Float32Array(this.properties.texCoords);
        } else {
            data.texCoords = new Float32Array(this.properties.texcoordCount * 2);
        }

        data.indices = new Uint32Array(this.properties.indices);

        this.setDescriptors(data);

        data = null;
    }
}

Factory.register(IndexedFacetSet);
